import React, { Component } from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import { getPaginationConfig } from '../../../components/pagination';
import { Table, Button, Modal } from 'antd';
import { QuestionCircleFilled, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import FormModal from './FormModal';
const { confirm } = Modal;
@inject('webEDIShipToStore')
@observer
class SearchResult extends Component {
  state={
    addModalVisible: false,
    record: null
  }
  componentDidMount() {
    const { webEDIShipToStore } = this.props;
    webEDIShipToStore.onChangeShipToList([])
    webEDIShipToStore.onChangePageNo()
  }
  handleEdit=(record)=>{
    this.setState({
      addModalVisible: true,
      record: record,
    })
  }
  handleCancel=()=>{
    this.setState({
      addModalVisible: false
    })
  }
  handleDel=(record)=>{
    const { webEDIShipToStore } = this.props;
    confirm({
      title: 'Delete Data',
      icon: <QuestionCircleFilled />,
      content: 'Are you sure you want to delete it ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk() {
        webEDIShipToStore.onDeleteShipToAction({ id: record.id, isDel: 1});
      },
      onCancel() {
        console.log('Cancel');
      },
    })
    return false;
  }
  handlePageChange = (page, pageSize) => {
    const { webEDIShipToStore } = this.props;
    webEDIShipToStore.onChangePageNumAction(page, pageSize);
  }
  getRowClassName = (record, index) => {
    let className = '';
    className = index % 2 === 0 ? 'oddRow' : 'evenRow';
    return className;
  }
  render() {
    const { webEDIShipToStore } = this.props
    const { pageNo, pageSize, itemCount, shipToList } = webEDIShipToStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange);
      return (
        <>
          <Table className='searchResult' dataSource={toJS(shipToList)} pagination={pagination} rowClassName={this.getRowClassName} rowKey="id">
            <Table.Column title='Ship To' dataIndex="shipTo" key="shipTo" />
            <Table.Column title='Sold To' dataIndex="soldTo" key="soldTo" />
            <Table.Column title='Ship To GLN' dataIndex="shipToGln" key="shipToGln" />
            <Table.Column title='Sold To GLN' dataIndex="soldToGln" key="soldToGln" />
            <Table.Column title='Created By' dataIndex="createdBy" key="createdBy" />
            <Table.Column title='Update Date' dataIndex="modifiedAt" key="modifiedAt" />
            <Table.Column align='center' title="Action" key="Action" render={(text, record) => (
              <>
                <Button onClick={() => this.handleEdit(record)} type='link' icon={<EditOutlined />} title='Edit' />
                <Button type='link' onClick={() => this.handleDel(record)} icon={<DeleteOutlined />} title='Delete' />
              </>
            )}/>
          </Table>
          {this.state.addModalVisible?<FormModal
            addModalVisible={this.state.addModalVisible}
            handleCancel={this.handleCancel}
            title='edit'
            record={this.state.record}
          />:null}
        </>
      );
  }
}

export default SearchResult;
